import get from 'lodash/get';
import { Market } from 'common/consts/markets';

export const getCurrentMarket = (PageData: any) => {
  if (PageData) {
    return get(PageData, 'Name', Market.FR);
  }
}

export const getMarketDateFormat = (market: string) => {
  switch (market) {
    case Market.PL:
    case Market.DE:
      return 'dd.MM.yyyy';
    case Market.NL:
    case Market.BE:
      return 'dd-MM-yyyy';
    default:
      return 'dd/MM/yyyy';
  }
}
